import { render, staticRenderFns } from "./insuranceProducts.vue?vue&type=template&id=a28afc44&scoped=true&"
import script from "./insuranceProducts.vue?vue&type=script&lang=js&"
export * from "./insuranceProducts.vue?vue&type=script&lang=js&"
import style0 from "./insuranceProducts.vue?vue&type=style&index=0&id=a28afc44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28afc44",
  null
  
)

export default component.exports